<template>
  <div id="test">

    <h2>Data Store</h2>

    <div class="report-content">

      <p style="margin-top: 1rem">The following represents the current client object, and is used for basic testing during development.</p>

      <pre>
        {{ getValue }}
      </pre>

    </div>    

  </div>
</template>

<script>

export default {
  
  computed: {

    getValue() {

      return this.$store.getters.getAllData();

    }

  },

  props : [

    // Default props
    'field',
    'label',

  ],   

}

</script>

<style>
  
  #test pre {

    font-size: 10px;
    background: #f4f4f4;
    padding: 1rem;
    margin-top: 1.5rem;

  }
</style>



// WEBPACK FOOTER //
// Developer.vue?3bdaefc6